/**
 * Academy content model. Lessons are plain data reviewed in pull requests: no CMS. Text may hold
 * `{name}` placeholders that are filled in from live settings when the lesson is shown (see
 * ACADEMY_VAR_NAMES), so a lesson never states a number the platform no longer uses.
 */
/** Placeholders a lesson may use, with the value used when the live setting can't be read. */
export const ACADEMY_VAR_DEFAULTS = {
    brand: 'Traders Portal',
    warning: '60%',
    critical: '45%',
    stopOut: '30%',
    swapHour: '22:00 UTC',
    swapTripleDay: 'Wednesday',
    refL1: '30%',
    refL2: '3%',
    refL3: '2%',
    refBonus: '$250',
    refWindow: '7 days',
    firstTier: 'Wood',
    topTier: 'Champion',
    tierCount: '7',
    firstCashback: '5%',
    topCashback: '25%',
};
export const ACADEMY_VAR_NAMES = Object.keys(ACADEMY_VAR_DEFAULTS);
//# sourceMappingURL=types.js.map